import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconPencilProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconPencil: React.FC<IconPencilProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Edit',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="m15 5 4 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconPencil;
